// extracted by mini-css-extract-plugin
export default {"semi-bold":"BrandNames_semi-bold__aDFSb"};